<template>
	<div class="coupon">
		<div class="coupon_01">
			<img src="@assets/images/handsel_0.jpg">
			<p>《<strong>{{coupon_title}}</strong>》限额签约优惠券</p>
		</div>
		<div class="coupon_02">
			<img src="@assets/images/handsel_1.jpg">
			<p class="product">《{{coupon_title}}》专用</p>
			<p class="money">{{coupon_price}}</p>
			<p class="couponcode">NO.{{code}}</p>
			<div class="received">
				<p v-if="is_permanent == 1">
					<span>已领</span>
					<span><i>{{receiv_count}}</i>张</span>
				</p>
				<p v-if="is_permanent == 0">
					<span>仅剩</span>
					<span><i>{{remain_count}}</i>个名额</span>
				</p>
			</div>
		</div>
		<div class="infobox">
			<div class="info">
				<p class="infop1">本优惠券下单时自动减免1000元</p>
				<div class="infodiv">
					<p>签约《提分宝典》“VIP助学小群班”</p>
					<p>确保提升30~160分</p>
					<p>包头地区1万余名考生，限招300人（7理、3文）</p>
					<p>前100位报名者优惠1000元，数量有限，领完为止</p>
					<p>领券后1小时内下单有效，逾时名额作废</p>
				</div>
				<div class="button">
					<div class="button_l">
						<div class="paybtn" @click="useCoupon(jump_url)">立即付款使用</div>
						<p class="infop2">立即付款，下单即赠</p>
						<p>698元的《我的手边题本》</p>
					</div>
					<div class="button_r">
						<div class="handselbtn" @click="goCat(productid)">立即付定金使用</div>
						<p class="infop2">定金100元，确定名额</p>
						<p>现场签约，补齐余款</p>
					</div>
				</div>
				<div class="infodiv">
					<p>付款后请于2020年5月31日13时~18时任意时段至</p>
					<p class="infop3">包钢文化宫一楼多功能厅(昆都仑区少先路141号)</p>
					<p class="infop4">清北名师现场签约</p>
				</div>
				<div class="indexbutton" @click="$router.push('/')">进入学习严选 >></div>
				<div class="bhight"></div>
			</div>
		</div>
	</div>
</template>
<script>
import { activityCoupon } from "@api/user";
import { getProductDetail, postCartAdd } from "@api/store";
export default {
	name: "HandselCoupon",
	components: {},
	props: {},
	data: function() {
		return {
			coupon_title:"提分宝典",
			coupon_price:"1000",
			receiv_count:"3000",//已领张数
			remain_count:"20",//剩余张数
			is_permanent:0,
			code:"T76768",
			jump_url:"/",
			productid:78,
			productValue: [],
			attr: {
			  cartAttr: false,
			  productAttr: [],
			  productSelect: {},
			  RuleData:{}
			},
		}
	},
	created() {},
	watch: {
		$route(n){
			if(n){
				this.getActivityCoupon();
			}
		}
	},
	mounted: function() {
		this.$dialog.loading.open("正在加载中");
		this.getActivityCoupon();
		this.productCon();
	},
	methods: {
		getActivityCoupon(){
			let that = this;
			activityCoupon(that.$route.params.id).then(res=>{
				that.coupon_title = res.data.issueUserInfo.coupon_title;
				that.coupon_price = res.data.issueUserInfo.coupon_price;
				that.receiv_count = res.data.issueCouponInfo.receiv_count;
				that.remain_count = res.data.issueCouponInfo.remain_count;
				that.is_permanent = res.data.issueCouponInfo.is_permanent;
				that.product_id = res.data.issueCouponInfo.product_id;
				that.code = res.data.issueUserInfo.code;
				that.jump_url = res.data.jump_url;
				that.$dialog.loading.close();
			}).catch(err => {
				that.$dialog.loading.close();
				that.$dialog.error(err.msg);
				if(err.msg == "领取的优惠劵已过期!"){
					setTimeout(function(){
						// that.$router.push("/");
					},1000);
				}
			});
		},
		useCoupon(url){
			window.location.href = url;
		},
		productCon: function() {
			let that = this,
			productid = that.productid;
			getProductDetail(productid).then(res => {
				that.$set(that, "productValue", res.data.productValue);
			}).catch(err => {
				that.$dialog.error(err.msg);
			});
		},
		goCat(id){
			let that = this,
			q = {
			  productId: id,
			  cartNum: 1,
			  new: 1,
			  spec_type: 0,
			  spec_values: "",
			  uniqueId: that.productValue["默认"].unique
			};
			postCartAdd(q).then(function(res) {
				that.$router.push({ path: "/order/submit/" + res.data.cartId });
			 }).catch(res => {
				return that.$dialog.toast({ mes: res.msg });
			 });
		},
	}
};
</script>
<style scoped>
	.coupon img {
		width: 100%;
		display: block;
	}
	.coupon_01{
		position: relative;
	}
	.coupon_01 p{
		width: 100%;
		position: absolute;
		top: 50%;
		font-size: 0.4rem;
		text-align: center;
	}
	.coupon_02 {
		position: relative;
	}
	.product{
		position: absolute;
		top: 10%;
		left: 15%;
		color: #fff;
		font-size: 0.3rem;
	}
	.money{
		position: absolute;
		top: 36%;
		left: 22%;
		font-size: 1rem;
		color: #ffd891;
	}
	.received {
		width: 1.4rem;
		height: 0.6rem;
		background: url("../../../assets/images/handsel_bg.png") no-repeat;
		background-size: 100% 100%;
		position: absolute;
		top: 30%;
		right: 9.7%;
		font-size: 12px;
		text-align: center;
	}
	.received span{
		display: block;
		line-height: 0.3rem;
	}
	.received i {
		color: #ed0301;
	}
	.couponcode{
		font-size: 0.2rem;
		position: absolute;
		top: 6%;
		right: 10.5%;
	}
	.infobox{
		background: url("../../../assets/images/handsel_2.jpg") no-repeat;
		background-size: 100% 100%;
		overflow: hidden;
		position: relative;
	}
	.info{
		width: 80.6%;
		margin: 0 auto;
	}
	.infodiv{
		width: 100%;
		background-color: #f8f8f8;
		border-radius: 5px;
		padding: 0.3rem 0;
		margin-top: 0.3rem;
	}
	.infodiv p{
		font-size: 0.25rem;
		color: #333;
		text-align: center;
		line-height: 0.38rem;
	}
	.infop1{
		font-size: 0.3rem;
		color: #f2221c;
		text-align: center;
		margin-top: 0.3rem;
	}
	
	.button{
		margin-top: 0.48rem;
		overflow: hidden;
	}
	.button_l,.button_r{
		width: 50%;
		float: left;
	}
	.paybtn,.handselbtn{
		width: 2.4rem;
		margin: 0 auto;
		padding: 0.15rem 0;
		border-radius: 17px;
		color: #fff;
		text-align: center;
		font-size: 0.27rem;
	}
	.paybtn{
		background-color: #09abff;
	}
	.handselbtn{
		background-color: #ff3329;
	}
	.button p{
		font-size: 0.2rem;
		color: #333;
		text-align: center;
	}
	.infop2{
		margin-top: 0.2rem;
	}
	.infodiv .infop3{
		color: #ff3329;
	}
	.infodiv .infop4{
		font-size: 0.3rem;
		font-weight: bold;
		margin-top: 0.15rem;
	}
	.indexbutton{
		text-align: center;
		font-size: 0.2rem;
		border: 1px solid #e2b847;
		border-radius: 15px;
		padding: 0.07rem 0.15rem;
		position: absolute;
		right: 0.8rem;
		bottom: 1.65rem;
	}
	.bhight{
		width: 100%;
		height: 2.57rem;
	}
</style>
